import { useT } from "@/app/translations/useT";
import { ConceptFlowStep } from "@/app/types/home/ConceptFlow";
import { formatStepNumber } from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";

type Props = {
  step: ConceptFlowStep;
};

export default function ConceptFlowStepLabel(props: Props) {
  const { step } = props;
  const T = useT();

  return (
    <div className={styles.step}>
      <span className={styles.stepTrack} aria-hidden="true">
        <span className={styles.stepTrackFill} />
      </span>
      <div className={styles.stepBody}>
        <div className={styles.stepHead} aria-hidden="true">
          <span className={styles.stepNumber}>{formatStepNumber(step.step)}</span>
          <span className={styles.stepRail} />
        </div>
        <h3 className={styles.stepName}>
          <span className={styles.srOnly}>{formatStepNumber(step.step)} </span>
          {T(step.nameKey)}
        </h3>
        <p className={styles.stepText}>{T(step.textKey)}</p>
      </div>
    </div>
  );
}
